export default class FragmentSummary {
    constructor(message = "", title = "", details = []) {
        this.title = title;
        this.message = message;
        this.details = details;
    }

    toString() {
        return this.message;
    }
}
